<template>
  <div>
    <TheNav
      v-model="showNav"
    />
    <v-app-bar
      app
      clipped-left
      color="secondary"
      id="toolbar"
      class="elevation-0"
    >
      <v-app-bar-nav-icon v-show="!showNav" @click="showMenu"></v-app-bar-nav-icon>
      <router-link :to="{name: 'dashboard'}" class="pa-0 ma-0 mlr-2">
        <img class="logo" src="/img/logo.png" />
      </router-link>
      <v-spacer></v-spacer>
      <small v-if="currentUser.user != undefined">
              {{ $t('LOGGED_AS') }} <br/> {{ currentUser.user.name }} {{ currentUser.user.surname }}
            </small>
      <v-toolbar-items>
        <v-btn text :to="{ name: routeName.USER_CHANGE_PWD }" class="pl-1 pr-1">
          <v-icon small>settings</v-icon>
        </v-btn>
        <v-btn text @click="handleLogout" class="pl-1 pr-1">
          <span class="hidden-sm-and-down mr-1">{{ $t('LOGOUT') }}</span>
          <v-icon small>power_settings_new</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import TheNav from './TheNav';

  export default {
    name: 'TheHeader',
    components: { TheNav },
    data() {
      return {
        showNav: true,
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
    },
    methods: {
      ...mapActions('auth', ['logout']),
      handleLogout() {
        this.logout();
      },
      showMenu() {
        this.showNav = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  #toolbar {
    .logo {
      height: 48px;
      display: flex;
      margin: 4px 0px;
    }
    .v-btn {
      font-size: 13px;
    }
  }
</style>
